module.exports = __webpack_public_path__ + "img/jacket-right-sub-raglan-zipper.770a848e.png";